import {ReducersMapObject, configureStore} from '@reduxjs/toolkit'
import {CompaniesApiSlice} from '../../app/features/companies/CompaniesApiSlice'
import {ServiceProvidersApiSlice} from '../../app/features/serviceProviders/ServiceProvidersApiSlice'
import {FinanciersApiSlice} from '../../app/features/financiers/FinanciersApiSlice'
import {DocumentsApiSlice} from '../../app/features/documents/DocumentsApiSlice'
import settingsReducer from './settingsReducer'
import {AuthApiSlice} from '../../app/features/auth/AuthApiSlice'
import {GrantProvidersApiSlice} from '../../app/features/developmentPartners/GrantProvidersApiSlice'
import {CallsApiSlice} from '../../app/features/calls/CallsApiSlice'
import {CorrespondenceApiSlice} from '../../app/features/correspondence/CorrespondenceApiSlice'
import priceReducer from './priceSlice'

const reducers: ReducersMapObject = {
  [CompaniesApiSlice.reducerPath]: CompaniesApiSlice.reducer,
  [ServiceProvidersApiSlice.reducerPath]: ServiceProvidersApiSlice.reducer,
  [FinanciersApiSlice.reducerPath]: FinanciersApiSlice.reducer,
  [DocumentsApiSlice.reducerPath]: DocumentsApiSlice.reducer,
  [AuthApiSlice.reducerPath]: AuthApiSlice.reducer,
  [GrantProvidersApiSlice.reducerPath]: GrantProvidersApiSlice.reducer,
  [CallsApiSlice.reducerPath]: CallsApiSlice.reducer,
  [CorrespondenceApiSlice.reducerPath]: CorrespondenceApiSlice.reducer,
  settings: settingsReducer,
  price: priceReducer,

}


const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
    thunk: true,
  }).concat(CompaniesApiSlice.middleware, ServiceProvidersApiSlice.middleware, FinanciersApiSlice.middleware, DocumentsApiSlice.middleware, AuthApiSlice.middleware, GrantProvidersApiSlice.middleware, CallsApiSlice.middleware, CorrespondenceApiSlice.middleware),
  devTools: process.env.NODE_ENV !== 'production',

})

export type RootState = ReturnType<typeof store.getState>


export default store

